<template>
  <base-section
    id="affiliates"
    class="grey lighten-4"
    space="36"
  >
    <v-container>
      <base-section-heading title="We Work On" />

      <v-slide-group>
        <template v-for="(brand, index) in brands">
          <v-slide-item
            :key="index"
            class="align-self-center"
          >
            <base-img
              :src="require(`@/assets/brands/${brand.name}.png`)"
              color="grey"
              contain
              height="40"
              width="128"
            />
          </v-slide-item>


        </template>
      </v-slide-group>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: 'SectionWeWorkOn',
  data() {
    return {
      brands: [
        {
          name: 'alfa-romeo_thumbnail',
        },
        {
          name: 'audi_thumbnail',
        },
        {
          name: 'bell_thumbnail',
        },
        {
          name: 'bmw_thumbnail',
        },
        {
          name: 'case_thumbnail',
        },
        {
          name: 'Chery_thumbnail',
        },
        {
          name: 'chevrolet_thumbnail',
        },
        {
          name: 'claas_thumbnail',
        },
        {
          name: 'datsun_thumbnail',
        },
        {
          name: 'dodge_thumbnail',
        },
        {
          name: 'faw_thumbnail',
        },
        {
          name: 'fiat_thumbnail',
        },
        {
          name: 'ford_thumbnail',
        },
        {
          name: 'foton_thumbnail',
        },
        {
          name: 'freightliner_thumbnail',
        },
        {
          name: 'GWM_thumbnail',
        },
        {
          name: 'haval_thumbnail',
        },
        {
          name: 'hino_thumbnail',
        },
        {
          name: 'honda_thumbnail',
        },
        {
          name: 'hyundai_thumbnail',
        },
        {
          name: 'international_thumbnail',
        },
        {
          name: 'isuzu_thumbnail',
        },
        {
          name: 'iveco_thumbnail',
        },
        {
          name: 'jaguar_thumbnail',
        },
        {
          name: 'jcb_thumbnail',
        },
        {
          name: 'jeep_thumbnail',
        },
        {
          name: 'jmc_thumbnail',
        },
        {
          name: 'johndeere_thumbnail',
        },
        {
          name: 'kia_thumbnail',
        },
        {
          name: 'komatsu_thumbnail',
        },
        {
          name: 'landrover_thumbnail',
        },
        {
          name: 'Magirus-Deutz_thumbnail',
        },
        {
          name: 'mahindra_thumbnail',
        },
        {
          name: 'man_thumbnail',
        },
        {
          name: 'masseyferguson_thumbnail',
        },
        {
          name: 'mazda_thumbnail',
        },
        {
          name: 'mercedes_thumbnail',
        },
        {
          name: 'mg_thumbnail',
        },
        {
          name: 'mitsubishi_thumbnail',
        },
        {
          name: 'nissan_thumbnail',
        },
        {
          name: 'peterbilt_thumbnail',
        },
        {
          name: 'powerstar_thumbnail',
        },
        {
          name: 'renault_thumbnail',
        },
        {
          name: 'rollsroyce_thumbnail',
        },
        {
          name: 'samil_thumbnail',
        },
        {
          name: 'ssangyong_thmbnail',
        },
        {
          name: 'subaru_thumbnail',
        },
        {
          name: 'suzuki_thumbnail',
        },
        {
          name: 'tata_thumbnail',
        },
        {
          name: 'toyota_thumbnail',
        },
        {
          name: 'volkswagen_thumbnail',
        },
        {
          name: 'volvo_thumbnail',
        },
      ],
    };
  },
};
</script>
